module.exports = __webpack_public_path__ + "img/5.6c2b16c9.png";